module.exports = __webpack_public_path__ + "static/media/waiting_approval.d6a8a06b.svg";